<template>
  <v-container fluid>

    <!-- รายงานตัวเลือกวิทยาลัย ตำแหน่งรองผู้อำนวยการ -->
    <v-card class="hrvec-alert-card mb-3" v-if="period_sedirectors_chooses.period_sedirector_enable === '1' || period_sedirectors_chooses.period_sedirector_enable === 1">
      <div class="hrvec-priority-bar urgent"></div>
      <v-card-text class="pa-0">
        <v-row no-gutters align="center">
          <v-col cols="12" md="8" class="hrvec-card-content-col">
            <div class="d-flex align-start">
              <div class="hrvec-icon-wrap mr-3" style="background: #455a64">
                <v-icon size="20" color="white">mdi-clipboard-account</v-icon>
              </div>
              <div>
                <div class="hrvec-badge-row">
                  <v-chip x-small color="info" outlined>
                    <v-icon left x-small>mdi-domain</v-icon>
                    กจ2. สอ. สอศ.
                  </v-chip>
                  <v-chip x-small color="primary">
                    <v-icon left x-small>mdi-account-check</v-icon>
                    รายงานตัวเลือก
                  </v-chip>
                </div>
                <h3 class="hrvec-card-title">รายงานตัวเลือกสถานศึกษา</h3>
                <p class="hrvec-card-subtitle mt-1 mb-0">
                  ตำแหน่ง รองผู้อำนวยการวิทยาลัย — ครั้งที่ {{ period_sedirectors_chooses.period_sedirector_times }}/{{ period_sedirectors_chooses.period_sedirector_year }}
                </p>
                <div class="mt-3">
                  <v-btn rounded depressed color="info" dark class="hrvec-action-button" to="/pages/sedirector_app_choose">
                    <v-icon small left>mdi-eye</v-icon>
                    ติดตามการรายงานตัวเลือกวิทยาลัย
                  </v-btn>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="hrvec-card-countdown-col">
            <div class="hrvec-card-countdown">
              <div class="hrvec-countdown-label">สถานะ</div>
              <div class="hrvec-countdown-date">เปิดระบบแล้ว</div>
              <p class="hrvec-card-subtitle mt-2 mb-0">สามารถรายงานตัวเลือกวิทยาลัยได้แล้ว</p>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- การรับสมัครคัดเลือกตำแหน่ง รองผู้อำนวยการวิทยาลัย -->
    <v-card class="hrvec-alert-card mb-3" v-if="period_sedirectors.period_sedirector_enable === '1' || period_sedirectors.period_sedirector_enable === 1">
      <div class="hrvec-priority-bar high"></div>
      <v-card-text class="pa-0">
        <v-row no-gutters align="center">
          <v-col cols="12" md="8" class="hrvec-card-content-col">
            <div class="d-flex align-start">
              <div class="hrvec-icon-wrap mr-3" style="background: #a86400">
                <v-icon size="20" color="white">mdi-account</v-icon>
              </div>
              <div>
                <div class="hrvec-badge-row">
                  <v-chip x-small color="warning" outlined>
                    <v-icon left x-small>mdi-account-plus</v-icon>
                    การสมัคร
                  </v-chip>
                  <v-chip x-small color="warning">
                    <v-icon left x-small>mdi-file-document</v-icon>
                    แนบไฟล์
                  </v-chip>
                </div>
                <h3 class="hrvec-card-title">เปิดระบบแนบไฟล์ การรับสมัครคัดเลือก</h3>
                <p class="hrvec-card-subtitle mt-1 mb-0">
                  ตำแหน่ง รองผู้อำนวยการวิทยาลัย — ให้ผู้สมัครที่ผ่านการคัดเลือก แนบไฟล์ประกอบการสมัคร
                </p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="hrvec-card-countdown-col">
            <div class="hrvec-card-countdown">
              <div class="hrvec-countdown-label">ปิดระบบ</div>
              <div class="hrvec-countdown-date">{{ dateToThai(period_sedirectors.period_sedirector_stop) }}</div>
              <div class="hrvec-countdown-flip-wrap mt-2">
                <flip-countdown :deadline="period_sedirectors.period_sedirector_stop + ' 16:30:00'" :labels="labels"></flip-countdown>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- การรับสมัครคัดเลือกตำแหน่ง ผู้อำนวยการวิทยาลัย -->
    <v-card class="hrvec-alert-card mb-3" v-if="period_directors.period_sedirector_enable === '1' || period_directors.period_sedirector_enable === 1">
      <div class="hrvec-priority-bar high"></div>
      <v-card-text class="pa-0">
        <v-row no-gutters align="center">
          <v-col cols="12" md="8" class="hrvec-card-content-col">
            <div class="d-flex align-start">
              <div class="hrvec-icon-wrap mr-3" style="background: #b3151b">
                <v-icon size="20" color="white">mdi-account-supervisor</v-icon>
              </div>
              <div>
                <div class="hrvec-badge-row">
                  <v-chip x-small color="primary" outlined>
                    <v-icon left x-small>mdi-account-star</v-icon>
                    ผู้อำนวยการ
                  </v-chip>
                  <v-chip x-small color="success">
                    <v-icon left x-small>mdi-check-circle</v-icon>
                    เปิดระบบ
                  </v-chip>
                </div>
                <h3 class="hrvec-card-title">เปิดระบบการรับสมัครคัดเลือก</h3>
                <p class="hrvec-card-subtitle mt-1 mb-0">
                  ตำแหน่ง ผู้อำนวยการวิทยาลัย — สามารถดำเนินการสมัครได้แล้ว
                </p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="hrvec-card-countdown-col">
            <div class="hrvec-card-countdown">
              <div class="hrvec-countdown-label">ปิดระบบ</div>
              <div class="hrvec-countdown-date">{{ dateToThai(period_directors.period_sedirector_stop) }}</div>
              <div class="hrvec-countdown-flip-wrap mt-2">
                <flip-countdown :deadline="period_directors.period_sedirector_stop + ' 16:30:00'" :labels="labels"></flip-countdown>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- ยื่นคำร้องขอย้าย ผู้อำนวยการ -->
    <v-card class="hrvec-alert-card mb-3" v-if="periodManages.period_enable === '1' || periodManages.period_enable === 1 && periodManages.period_type === 'manage'">
      <div class="hrvec-priority-bar high"></div>
      <v-card-text class="pa-0">
        <v-row no-gutters align="center">
          <v-col cols="12" md="8" class="hrvec-card-content-col">
            <div class="d-flex align-start">
              <div class="hrvec-icon-wrap mr-3" style="background: #b3151b">
                <v-icon size="20" color="white">mdi-account-arrow-right</v-icon>
              </div>
              <div>
                <div class="hrvec-badge-row">
                  <v-chip x-small color="primary" outlined>
                    <v-icon left x-small>mdi-swap-horizontal</v-icon>
                    การย้าย
                  </v-chip>
                  <v-chip
                    v-if="periodManages.period_normal_case === '1' || periodManages.period_normal_case === 1"
                    x-small color="primary"
                  >
                    <v-icon left x-small>mdi-briefcase</v-icon>
                    กรณีปกติ
                  </v-chip>
                  <v-chip
                    v-if="periodManages.period_quality_case === '1' || periodManages.period_quality_case === 1"
                    x-small color="info"
                  >
                    <v-icon left x-small>mdi-star</v-icon>
                    เพื่อพัฒนาคุณภาพการศึกษา
                  </v-chip>
                </div>
                <h3 class="hrvec-card-title">ยื่นคำร้องขอย้าย ตำแหน่งผู้อำนวยการวิทยาลัย</h3>
                <p class="hrvec-card-subtitle mt-1 mb-0">สามารถดำเนินการยื่นคำร้องขอย้ายได้แล้ว</p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="hrvec-card-countdown-col">
            <div class="hrvec-card-countdown">
              <div class="hrvec-countdown-label">ปิดระบบ</div>
              <div class="hrvec-countdown-date">{{ dateToThai(periodManages.period_stop) }}</div>
              <div class="hrvec-countdown-flip-wrap mt-2">
                <flip-countdown :deadline="periodManages.period_stop + ' 16:30:00'" :labels="labels"></flip-countdown>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- ยื่นคำร้องขอย้าย รองผู้อำนวยการ -->
    <v-card class="hrvec-alert-card mb-3" v-if="periodManages_se.period_enable === '1' || periodManages_se.period_enable === 1 && periodManages_se.period_type === 'manage'">
      <div class="hrvec-priority-bar high"></div>
      <v-card-text class="pa-0">
        <v-row no-gutters align="center">
          <v-col cols="12" md="8" class="hrvec-card-content-col">
            <div class="d-flex align-start">
              <div class="hrvec-icon-wrap mr-3" style="background: #b3151b">
                <v-icon size="20" color="white">mdi-account-arrow-right</v-icon>
              </div>
              <div>
                <div class="hrvec-badge-row">
                  <v-chip x-small color="primary" outlined>
                    <v-icon left x-small>mdi-swap-horizontal</v-icon>
                    การย้าย
                  </v-chip>
                  <v-chip
                    v-if="periodManages_se.period_normal_case === '1' || periodManages_se.period_normal_case === 1"
                    x-small color="primary"
                  >
                    <v-icon left x-small>mdi-briefcase</v-icon>
                    กรณีปกติ
                  </v-chip>
                </div>
                <h3 class="hrvec-card-title">ยื่นคำร้องขอย้าย ตำแหน่งรองผู้อำนวยการวิทยาลัย</h3>
                <p class="hrvec-card-subtitle mt-1 mb-0">สามารถดำเนินการยื่นคำร้องขอย้ายได้แล้ว</p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="hrvec-card-countdown-col">
            <div class="hrvec-card-countdown">
              <div class="hrvec-countdown-label">ปิดระบบ</div>
              <div class="hrvec-countdown-date">{{ dateToThai(periodManages_se.period_stop) }}</div>
              <div class="hrvec-countdown-flip-wrap mt-2">
                <flip-countdown :deadline="periodManages_se.period_stop + ' 16:30:00'" :labels="labels"></flip-countdown>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
// กำหนดการที่เลยวันสิ้นสุดแล้วไม่แสดง (กติกาเดียวกับศูนย์แจ้งเตือนสถานศึกษา)
import { activePeriod } from "@/utils/periodActive";
import FlipCountdown from "vue2-flip-countdown";

export default {
  name: "HRvecAlertMissionPersonnelDirector",
  components: { FlipCountdown },

  data() {
    return {
      ApiKey: "HRvec2021",
      period_sedirectors: [],
      period_directors: [],
      periodManages: [],
      labels: {
        days: "วัน",
        hours: "ชั่วโมง",
        minutes: "นาที",
        seconds: "วินาที"
      },
      period_sedirectors_chooses: [],
      periodManages_se: []
    };
  },

  async mounted() {
    await this.period_sedirectorQuery();
    await this.periodQueryManage();
    await this.period_sedirectorChooseQuery();
    await this.period_directorQuery();
    await this.periodQueryManageSe();
  },

  filters: {
    moment: function(date, operation, value) {
      if (!date) return "";

      if (operation === "add" && value === "543 years") {
        return {
          moment: function(format) {
            const d = new Date(date);
            d.setFullYear(d.getFullYear() + 543);
            if (format === "D MMMM YYYY") {
              return d.toLocaleDateString("th-TH", {
                day: "numeric",
                month: "long",
                year: "numeric"
              });
            }
            return d.toLocaleDateString("th-TH");
          }
        };
      }
      return date;
    }
  },

  methods: {
    dateToThai(dateString, format = "full") {
      const date = new Date(dateString);

      // เพิ่ม 543 ปี สำหรับปีพุทธศักราช
      const thaiYear = date.getFullYear() + 543;

      // ชื่อเดือนภาษาไทย
      const thaiMonths = [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม"
      ];

      // ชื่อเดือนสั้น
      const thaiMonthsShort = [
        "ม.ค.",
        "ก.พ.",
        "มี.ค.",
        "เม.ย.",
        "พ.ค.",
        "มิ.ย.",
        "ก.ค.",
        "ส.ค.",
        "ก.ย.",
        "ต.ค.",
        "พ.ย.",
        "ธ.ค."
      ];

      // ชื่อวันภาษาไทย
      const thaiDays = [
        "อาทิตย์",
        "จันทร์",
        "อังคาร",
        "พุธ",
        "พฤหัสบดี",
        "ศุกร์",
        "เสาร์"
      ];

      const day = date.getDate();
      const month = date.getMonth();
      const dayOfWeek = date.getDay();

      switch (format) {
        case "full":
          // วันจันทร์ที่ 31 กรกฎาคม พ.ศ. 2568
          return `วัน${thaiDays[dayOfWeek]}ที่ ${day} ${thaiMonths[month]} พ.ศ. ${thaiYear}`;

        case "short":
          // 31 ก.ค. 68
          return `${day} ${thaiMonthsShort[month]} ${String(thaiYear).slice(
            -2
          )}`;

        case "medium":
          // 31 กรกฎาคม 2568
          return `${day} ${thaiMonths[month]} ${thaiYear}`;

        case "date-only":
          // 31 กรกฎาคม พ.ศ. 2568
          return `${day} ${thaiMonths[month]} พ.ศ. ${thaiYear}`;

        case "with-day":
          // จันทร์ 31 กรกฎาคม 2568
          return `${thaiDays[dayOfWeek]} ${day} ${thaiMonths[month]} ${thaiYear}`;

        case "buddhist-era":
          // 31/07/2568
          return `${String(day).padStart(2, "0")}/${String(month + 1).padStart(
            2,
            "0"
          )}/${thaiYear}`;

        case "christian-era":
          // 31/07/2025
          return `${String(day).padStart(2, "0")}/${String(month + 1).padStart(
            2,
            "0"
          )}/${date.getFullYear()}`;

        default:
          return `${day} ${thaiMonths[month]} พ.ศ. ${thaiYear}`;
      }
    },
    async period_sedirectorChooseQuery() {
      let result_period_sedirector;
      result_period_sedirector = await this.$http.post(
        "period_sedirector.php",
        {
          ApiKey: this.ApiKey,
          period_sedirector_process: "1",
          period_sedirector_id: "206"
        }
      );
      this.period_sedirectors_chooses = activePeriod(result_period_sedirector.data);     
    },

    async period_directorQuery() {
      let result_period;
      result_period = await this.$http.post("period_sedirector.php", {
        ApiKey: this.ApiKey,
        period_sedirector_enable: "1",
        period_sedirector_id: "301"
      });
      this.period_directors = activePeriod(result_period.data);
    },

    async period_sedirectorQuery() {
      let result_period;
      result_period = await this.$http.post("period_sedirector.php", {
        ApiKey: this.ApiKey,
        period_sedirector_enable: "1",
        period_sedirector_id: "201"
      });
      this.period_sedirectors = activePeriod(result_period.data);
    },

    async periodQueryManage() {
      let result;
      result = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_id: "101"
      });
      this.periodManages = activePeriod(result.data);     
    },

    async periodQueryManageSe() {
      let result;
      result = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_id: "201"
      });
      this.periodManages_se = activePeriod(result.data);     
    }
  }
};
</script>

<style scoped>
/* Container */
.personnel-director-container {
  padding: 1rem;
  min-height: 100vh;
}

/* Dashboard Header */
.dashboard-header {
  background: var(--hv-hero);
  padding: 3rem 2rem;
  border-radius: 25px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.dashboard-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="20" cy="20" r="2" fill="rgba(255,255,255,0.1)"/><circle cx="80" cy="40" r="3" fill="rgba(255,255,255,0.1)"/><circle cx="40" cy="80" r="1" fill="rgba(255,255,255,0.1)"/></svg>');
  pointer-events: none;
}

.header-content {
  position: relative;
  z-index: 1;
}

.header-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.header-subtitle {
  font-size: 1.2rem;
  opacity: 0.9;
  margin: 0;
}

/* Mission Cards */
.mission-card {
  border-radius: 20px !important;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.mission-card.card-hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 25px 70px rgba(0, 0, 0, 0.15) !important;
}

/* Mission Stripes */
.mission-stripe {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 6px;
  z-index: 1;
}

.mission-stripe.selection {
  background: linear-gradient(45deg, #455a64, #455a64);
}

.mission-stripe.application {
  background: linear-gradient(45deg, #a86400, #a86400);
}

.mission-stripe.director {
  background: linear-gradient(45deg, #b3151b, #b3151b);
}

.mission-stripe.transfer {
  background: linear-gradient(45deg, #b3151b, #b3151b);
}

/* Mission Content */
.mission-content {
  padding-left: 20px;
}

.mission-badge {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.mission-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: #263238;
  margin-bottom: 1rem;
  line-height: 1.4;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.mission-subtitle {
  font-size: 1.2rem;
  font-weight: 600;
  color: #263238;
}

.highlight-text {
  background: linear-gradient(120deg, #90a4ae 0%, #fbecec 100%);
  padding: 2px 8px;
  border-radius: 8px;
  font-weight: 700;
  color: #263238;
}

/* Mission Details */
.mission-details {
  margin-top: 1rem;
}

.detail-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 0.75rem;
  font-size: 1rem;
  line-height: 1.6;
}

.detail-item:last-child {
  margin-bottom: 0;
}

/* Action Section */
.action-section {
  margin-top: 1.5rem;
}

.action-btn {
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s ease !important;
  min-height: 48px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
  min-width: 220px;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15) !important;
}

/* Countdown Container */
.countdown-container {
  text-align: center;
  padding: 2rem;

  border-radius: 20px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.countdown-header {
  margin-bottom: 1.5rem;
}

.countdown-title {
  font-size: 1rem;
  font-weight: 600;
  color: #263238;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.deadline-date {
  font-size: 1.1rem;
  font-weight: 700;
  color: #455a64;
  margin-bottom: 0.5rem;
}

.countdown-label {
  font-size: 0.9rem;
  color: #666;
  margin: 0;
}

.countdown-timer {
  margin: 1.5rem 0;
}

.countdown-timer >>> .flip-countdown {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.countdown-timer >>> .flip-countdown__piece {
  background: linear-gradient(145deg, #d9777b, #b3151b) !important;
  border-radius: 12px !important;
  font-weight: 700 !important;
  font-size: 1.4rem !important;
  min-width: 60px !important;
  height: 60px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4) !important;
  border: 2px solid rgba(255, 255, 255, 0.2) !important;
}

.countdown-timer >>> .flip-countdown__slot {
  font-size: 0.85rem !important;
  color: #666 !important;
  margin-top: 8px !important;
  font-weight: 600 !important;
}

/* Info Container */
.info-container {
  padding: 2rem;
  border-radius: 20px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  text-align: center;
}

.info-header {
  margin-bottom: 1.5rem;
}

.info-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #263238;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.status-info {
  text-align: center;
}

.status-text {
  font-size: 0.9rem;
  color: #666;
  margin: 0;
}

/* Text Utilities */
.text-error {
  color: #d32f2f !important;
  font-weight: 600;
}

.text-primary {
  color: #455a64 !important;
  font-weight: 600;
}

.text-info {
  color: #455a64 !important;
  font-weight: 600;
}

.text-success {
  color: #2e7d32 !important;
  font-weight: 600;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .header-title {
    font-size: 2.2rem;
  }

  .mission-title {
    font-size: 1.4rem;
  }
}

@media (max-width: 768px) {
  .dashboard-header {
    padding: 2rem 1rem;
    border-radius: 15px;
  }

  .header-title {
    font-size: 1.8rem;
  }

  .header-subtitle {
    font-size: 1rem;
  }

  .mission-title {
    font-size: 1.3rem;
    flex-direction: column;
    align-items: flex-start;
  }

  .action-btn {
    width: 100%;
    margin-top: 1rem;
    min-width: auto;
  }

  .countdown-container,
  .info-container {
    margin-top: 2rem;
    padding: 1.5rem;
  }

  .countdown-timer >>> .flip-countdown__piece {
    min-width: 50px !important;
    height: 50px !important;
    font-size: 1.2rem !important;
  }
}

@media (max-width: 600px) {
  .personnel-director-container {
    padding: 0.5rem;
  }

  .mission-card {
    margin-bottom: 1.5rem;
  }

  .detail-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .detail-item .v-icon {
    margin-bottom: 4px;
  }

  .mission-badge {
    flex-direction: column;
    align-items: flex-start;
  }

  .countdown-timer >>> .flip-countdown {
    gap: 8px;
  }

  .countdown-timer >>> .flip-countdown__piece {
    min-width: 45px !important;
    height: 45px !important;
    font-size: 1rem !important;
  }
}

/* Animation Effects */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.mission-card {
  animation: fadeInUp 0.6s ease-out;
}

.mission-card:nth-child(2) {
  animation-delay: 0.1s;
}
.mission-card:nth-child(3) {
  animation-delay: 0.2s;
}
.mission-card:nth-child(4) {
  animation-delay: 0.3s;
}
.mission-card:nth-child(5) {
  animation-delay: 0.4s;
}

/* Vuetify Overrides */
.v-chip.v-chip--outlined {
  border-width: 2px !important;
  font-weight: 600 !important;
}

.v-btn {
  text-transform: none !important;
}

/* Focus States for Accessibility */
.action-btn:focus {
  outline: 3px solid rgba(25, 118, 210, 0.5);
  outline-offset: 2px;
}

.mission-card:focus-within {
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.3);
}

/* Loading States */
.loading-shimmer {
  background-size: 200% 100%;
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

/* Special Chip Styles */
.v-chip.v-size--small {
  font-size: 0.75rem !important;
  height: 24px !important;
}

/* Custom Badge Animations */
.mission-badge .v-chip {
  transition: all 0.3s ease;
}

.mission-badge .v-chip:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* Status Indicators */
.status-indicator {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 600;
}

.status-indicator.active {
  background-color: rgba(76, 175, 80, 0.1);
  color: #2e7d32;
}

.status-indicator.pending {
  background-color: rgba(255, 152, 0, 0.1);
  color: #a86400;
}

.status-indicator.expired {
  background-color: rgba(244, 67, 54, 0.1);
  color: #f44336;
}

/* Enhanced Mission Cards Effects */
.mission-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transform: translateX(-100%);
  transition: transform 0.6s;
  pointer-events: none;
}

.mission-card:hover::before {
  transform: translateX(100%);
}

/* Priority Indicators */
.priority-high {
  position: relative;
}

.priority-high::after {
  content: "";
  position: absolute;
  top: 10px;
  right: 10px;
  width: 12px;
  height: 12px;
  background: #f44336;
  border-radius: 50%;
  animation: pulse-priority 2s infinite;
}

@keyframes pulse-priority {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.2);
  }
}

/* Gradient Text Effects */
.gradient-text {
  background: linear-gradient(45deg, #d9777b, #b3151b);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 700;
}

/* Enhanced Countdown Styling */
.countdown-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  border-radius: 20px;
  pointer-events: none;
}

/* Micro-interactions */
.detail-item:hover .v-icon {
  transform: scale(1.1);
  transition: transform 0.2s ease;
}

.mission-title:hover .v-icon {
  transform: rotate(5deg) scale(1.1);
  transition: transform 0.3s ease;
}

/* Print Styles */
@media print {
  .mission-card {
    break-inside: avoid;
    box-shadow: none !important;
    border: 1px solid #ccc;
  }

  .countdown-timer {
    display: none;
  }

  .action-btn {
    display: none;
  }
}
</style>
